var LOCALE = window.LOCALE || {};
LOCALE.ru = {
    ERROR: 'Упс!',
    ERROR_UNDEFINED: 'Неизвестная ошибка',
    ERROR_APP: 'Произошла какая-то ошибка. Пожалуйста, обновите страницу, чтобы продолжить. Если ошибка будет повторяться, обратитесь в службу поддержки. Приносим извинения за неудобства.',
    ERROR_REQUIRED_FP_VER: 'Чтобы продолжить, надо разрешить работу флеш-плеера на этой странице.\nМинимальная версия флеш-плеера - ',
    ACTION_UPDATE_FP: 'Разрешить',
    PLEASE_RELOAD: 'Пожалуйста, обновите страницу',
    ACTION_RELOAD: 'Обновить',
    GAME: 'Игра',
    SUPPORT: 'Поддержка',
    COMMUNITY: 'Сообщество',
    YOUR_ID: 'Ваш ID',
    LOADING: 'Загрузка',
    GAME_NAME: 'Арена Легенд',
    ERROR_SOCIAL: 'Произошла ошибка социальной сети',
    LIKE_BUTTON_TITLE: 'Арена Легенд',
    LIKE_BUTTON_DESCRIPTION: 'Игра Арена Легенд',
    FAQ: 'ЧаВо',
    ACTION_INVITE: 'Пригласить',
    SIG_SERVER_22: 'На сервере ведутся работы. Больше информации вы сможете найти в сообществе игры.',
    INVITE_MESSAGE: 'Сразись со мной в новой стратегии. Нас ждут великие битвы!',
    INVITE_TITLE: 'Арена Легенд!',
    FP_DIALOG_MESSAGE1: 'Для начала игры нужно запустить Flash-плеер',
    FP_DIALOG_ENABLE1: 'Если окно не появилось, перейдите в настройки по адресу',
    FP_DIALOG_ENABLE2: 'chrome://settings/content/flash',
    FP_DIALOG_ENABLE3: 'Отключите настройку “Запретить сайтам запускать Flash”, после чего нажмите кнопку "Запустить!" ещё раз.',
    FP_DIALOG_RUN: 'Запустить!',
    FP_DIALOG_ALLOW: 'Нажмите "Разрешить" в появившемся диалоговом окне.',
    SWF_PLAYER_FALLBACK_NOTICE: 'Если при загрузке игры у вас возникли проблемы, попробуйте переключиться на Flash-версию.',
    SWITCH_TO_SWF_PLAYER: 'Flash версия',
    SWITCH_TO_HTML_PLAYER: 'HTML версия',
    MESSAGE_AUTH_REQUIRED: 'Для продолжения игры и сохранения прогресса игрока требуется авторизация.',
    ACTION_AUTHENTICATE: 'Старт!'
};